var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgZoomIn = function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zoom-in_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 31C24.06 31 31 24.06 31 15.5 31 6.94 24.06 0 15.5 0 6.94 0 0 6.94 0 15.5 0 24.06 6.94 31 15.5 31Z",
    fill: "#000",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.62 8.086c-.106.106-.114.172-.141 1.11-.015.498-.01.704.015.765.068.165.138.181.903.212.385.016.74.029.788.03.08 0-.066.154-1.516 1.608-1.093 1.096-1.61 1.634-1.623 1.689-.01.046 0 .121.023.176.023.053.31.363.64.69.578.574.604.595.717.595.064 0 .149-.021.189-.048.04-.026.776-.75 1.636-1.608l1.563-1.56.003.338c.004.662.043 1.245.087 1.314a.387.387 0 0 0 .139.112c.085.04.187.042.908.013.89-.037.945-.049 1.024-.214.04-.085.036-.327-.044-2.492-.06-1.605-.1-2.423-.124-2.474-.056-.123-.164-.174-.392-.186-.432-.023-4.244-.156-4.47-.156-.225 0-.243.005-.325.086Zm-5.79 9.563c-.88.88-1.61 1.6-1.622 1.6-.012 0-.023-.148-.024-.33-.005-.656-.044-1.238-.088-1.307a.386.386 0 0 0-.138-.112c-.085-.04-.19-.042-.907-.013-.89.036-.947.048-1.026.215-.04.085-.036.324.044 2.491.06 1.614.1 2.423.124 2.474.045.1.14.161.28.18.062.008 1.16.05 2.438.094 2.527.087 2.416.09 2.524-.075.067-.102.13-1.677.073-1.815-.07-.168-.138-.184-.905-.215a78.792 78.792 0 0 0-.772-.029c-.059 0 .226-.3 1.515-1.594 1.707-1.712 1.674-1.674 1.584-1.882-.022-.051-.31-.361-.64-.688-.597-.594-.6-.595-.729-.595h-.13l-1.6 1.6Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zoom-in_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h31v31H0z"
  })))));
};

export default SvgZoomIn;